import { gql } from "@apollo/client"

export const VariableCompensationFragment = gql`
  fragment VariableCompensationFragment on VariableCompensation {
    id
    label
    amount {
      subunit
      formatted
      currencyCode
    }
    changeReason
    amountAsPercentage
    compensationType
    customLabel
    effectiveEndDate
    effectiveDate
    guaranteed
    includedInGrossSalary
    statutory
    systemGenerated
    paymentFrequency
    selectedMonths
    prorated
    variableCompensationTemplate {
      id
      amount {
        subunit
        formatted
        currencyCode
      }
    }
    editedAfterCreationFromTemplate
  }
`

export const VariableCompensationInputFragment = gql`
  fragment BonusInputFragment on Bonus {
    label
    customLabel
    amountType
    fixedAmount {
      amount
      currencyCode
    }
    amountAsPercentage
    paymentFrequency
    guaranteed
    selectedMonths
  }
  fragment AllowanceInputFragment on Allowance {
    label
    customLabel
    amountType
    fixedAmount {
      amount
      currencyCode
    }
    amountAsPercentage
    paymentFrequency
    guaranteed
    selectedMonths
  }
`

export const VariableCompensationTemplateFragment = gql`
  fragment VariableCompensationTemplateFragment on VariableCompensationTemplate {
    id
    label
    amount {
      subunit
      formatted
      currencyCode
    }
    amountAsPercentage
    compensationType
    guaranteed
    paymentFrequency
    selectedMonths
    statutory
    systemGenerated
    prorated
  }
`

// Currently there's a problem with the statutory and systemGenerated field's implementation in the mutations,
// so I'm not returning it in the payload.
export const VariableCompensationTemplatePayloadFragment = gql`
  fragment VariableCompensationTemplatePayloadFragment on VariableCompensationTemplate {
    id
    label
    amount {
      subunit
      formatted
      currencyCode
    }
    amountAsPercentage
    compensationType
    guaranteed
    paymentFrequency
    selectedMonths
    prorated
  }
`
